import request from './request';

const Novelty = {
    getNoveltiesProducts: ({ params }) => {
        // remove order history from the API
        params.withoutOrderHistory = true;
        return request({
            url: `/api/novelty/`,
            method: 'GET',
            params: params,
        });
    },
};

export default Novelty;
